<template>
  <v-container class="pd-0-f bg-white">
    <v-row v-if="activeMenu == 0" no-gutters>
      <v-col cols="2" align="center">
        <div class="pd-4">
          <img
            style="border-radius: 5px 0; width: 100%"
            src="assets/mnuac/mnuac.ico"
          />
        </div>
        <v-btn-toggle style="flex-direction: column;" borderless>
          <v-btn outlined :value="1" @click="init(1)">
            <feather
              style="color:#b62c33"
              type="users"
              class="ht-20-f wd-20-f"
            ></feather>
          </v-btn>
          <v-btn outlined :value="3" @click="init(3)">
            <feather
              style="color:#b62c33"
              type="music"
              class="ht-20-f wd-20-f"
            ></feather>
          </v-btn>
          <v-btn outlined :value="4" @click="init(4)">
            <feather
              style="color:#b62c33"
              type="aperture"
              class="ht-20-f wd-20-f"
            ></feather>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="10">
        <v-carousel
          class="suis-carsl mg-b-20"
          cycle
          height="35vh"
          continuous
          vertical
          show-arrows
          hide-delimiters
          transition="fade-transition"
          style="border-radius: 0 0 0 20px"
        >
          <v-carousel-item
            @click="showTask(t)"
            v-for="(t, i) in tasks"
            :key="i"
          >
            <v-sheet
              height="100%"
              :style="
                `background: url('${t.defaultAttachmentUrl}?w=420') no-repeat center top`
              "
            >
              <div
                class="pd-10-f font-weight-regular"
                style="font-size: 12px; background: rgba(177, 45, 47, .7); bottom: 0; position: absolute; width: 100%"
              >
                {{ t.task }}
              </div>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col cols="10">
        <v-card elevation="10" style="border-radius: 0 20px 0 0">
          <template v-for="(t, i) in news">
            <v-card
              @click="showTask(t)"
              :key="i"
              class="mg-x-0 pd-y-5 pd-l-20"
              elevation="0"
              style="box-shadow: none"
            >
              <div class="d-flex flex-no-wrap justify-space-between">
                <div class="tytyty">
                  <img
                    :src="`${t.defaultAttachmentUrl}?w=60&h=100&mode=crop`"
                    style="border-radius: 10px"
                  />
                </div>
                <div class="pd-l-20 tytydesc">
                  <div class="pd-0-f mg-b-4 tytyty-title">
                    <span class="text-lowercase">{{ t.task }}</span>
                  </div>
                  <iframe
                    :src="
                      `https://www.facebook.com/plugins/share_button.php?href=http://mnuac.edu.mn/main/383792?content=${t.id}&layout=button&size=small&width=96&height=20`
                    "
                    width="96"
                    height="20"
                    style="border:none;overflow:hidden"
                    scrolling="no"
                    frameborder="0"
                    allowTransparency="true"
                    allow="encrypted-media"
                  ></iframe>
                  <div style="font-size: 12px" class="font-weight-regular">
                    {{ t.createdDate | moment("DD.MM.YYYY") }}
                  </div>
                </div>
              </div>
            </v-card>
            <v-divider :key="'vd' + i" />
          </template>
        </v-card>
      </v-col>
      <v-col align="right" cols="2" class="pl-1 fdsdfsdfdsfsdf">
        <v-banner sticky>
          <v-tabs grow vertical hide-slider height="280" :value="activeTab">
            <v-tab
              @click="initTab(0)"
              style=" transform: rotate(90deg); max-width: 20px !important"
              class="pd-t-25"
              height="200"
              >онцлох</v-tab
            >
            <v-tab
              @click="initTab(1)"
              style=" transform: rotate(90deg); max-width: 20px !important"
              class="pd-t-25"
              >шинэ</v-tab
            >
            <v-tab
              @click="initTab(2)"
              style=" transform: rotate(90deg); max-width: 20px !important"
              class="pd-t-25"
              >их үзсэн</v-tab
            >
          </v-tabs>
        </v-banner>
      </v-col>
    </v-row>

    <v-row v-else-if="activeMenu == 1" no-gutters>
      <v-btn @click="init(0)" icon class="mg-t-10">
        <feather type="chevron-left" class="ht-25-f wd-25-f"></feather>
      </v-btn>
      <div class="mg-10-f pd-x-10 pd-y-5" style="border: 1px solid #000">
        <v-icon>mdi-newspaper</v-icon>
        <span style="border-left: 1px solid #000" class="pl-2 ml-2"
          >Бидний тухай</span
        >
      </div>
      <v-card
        @click="showTask(t)"
        v-for="t in top1"
        :key="t.id"
        width="100%"
        elevation="0"
        class="mg-y-20 mx-3"
      >
        <v-img
          :src="`${t.defaultAttachmentUrl}?w=360&h=380&mode=crop`"
          style="border-radius: 10px"
        ></v-img>
        <div class="mx-2 text-uppercase">{{ t.st1 }}</div>
        <span class="mx-2 grey--text">{{ t.st2 }}</span>
        <v-divider class="mg-y-20"></v-divider>
      </v-card>

      <v-row no-gutters class="viceDirectors">
        <v-col
          v-for="t in mid9"
          :key="t.id"
          class="pd-l-15-f pd-r-15-f"
          cols="6"
        >
          <v-card @click="showTask(t)" style="border-radius: 10px">
            <v-img
              :src="`${t.defaultAttachmentUrl}?w=200&h=300&mode=crop`"
              style="border-radius: 10px"
              class="mg-b-20"
            ></v-img>
            <div class="desc-outer">
              <div
                class="desc-title font-weight-regular px-2 py-1 text-uppercase"
              >
                {{ t.st1 }}
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
    <v-row v-else-if="activeMenu == 2" no-gutters>
      <v-app-bar
        style="background:#b62c33"
        dark
        dense
        flat
        fixed
        hide-on-scroll
      >
        <feather type="chevron-left" class="ht-25-f wd-25-f"></feather>
        <!-- <v-icon @click="init(0)" class="mr-3">mdi-backburger</v-icon> -->
        <v-icon class="mr-3">mdi-school-outline</v-icon>
        <v-toolbar-title
          ><template v-if="tasks.length > 0">{{ tasks.length }}-н</template>
          Сургалт</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="drawerRight = true">
          <feather type="search" class="ht-25-f wd-25-f"></feather>
        </v-btn>
      </v-app-bar>
      <v-divider class="mb-10" />
      <div v-for="(t, i) in tasks" :key="i">
        <div style="width: 100%">
          <v-divider class="my-2" />
        </div>
        <v-card @click="showTask(t)" class="mx-1 py-3" elevation="0">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar class="ma-1" size="120" tile style="border-radius: 10px">
              <v-img :src="`${t.defaultAttachmentUrl}?w=200`"></v-img>
            </v-avatar>
            <div class="pl-2">
              <v-card-subtitle
                class="pa-0 font-weight-bold text-uppercase"
                v-text="t.task"
              ></v-card-subtitle>
              <div style="font-size: 12px" class="font-weight-regular">
                Сургууль: <b>{{ t.locType3Name }}</b>
              </div>
              <div style="font-size: 12px" class="font-weight-regular">
                Болох хугацаа: <b>{{ t.locType4Name }}</b>
              </div>
              <div style="font-size: 12px" class="font-weight-regular">
                Сургалтын хэлбэр: <b>{{ t.locType5Name }}</b>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </v-row>
    <v-row v-if="activeMenu == 3 || activeMenu == 4" no-gutters>
      <v-btn @click="init(0)" icon class="mg-t-10">
        <feather type="chevron-left" class="ht-25-f wd-25-f"></feather>
      </v-btn>
      <div class="mg-y-10-f pd-x-10 pd-y-5" style="border: 1px solid #000">
        <v-icon>mdi-newspaper</v-icon>
        <span style="border-left: 1px solid #000" class="pl-2 ml-2">
          {{ activeMenu == 4 ? "Эрдэм шинжилгээ" : "Уран бүтээл" }}</span
        >
      </div>
      <v-col cols="12">
        <v-card flat>
          <template v-for="(t, i) in tasks">
            <v-card
              @click="showTask(t)"
              :key="i"
              class="mg-x-5 pd-y-10 pd-l-10"
              elevation="0"
            >
              <div class="d-flex flex-no-wrap justify-space-between">
                <v-avatar
                  class="mg-a-5"
                  size="160"
                  tile
                  style="border-radius: 10px"
                >
                  <v-img :src="`${t.defaultAttachmentUrl}?w=300`"></v-img>
                </v-avatar>
                <div class="pd-l-10 tytydesc">
                  <div class="pa-0 mb-3">
                    {{ t.task }}
                  </div>
                  <div style="font-size: 12px" class="font-weight-regular">
                    Нийтлэгдсэн: {{ t.createdDate | moment("DD.MM.YYYY") }}
                  </div>
                </div>
              </div>
            </v-card>
            <v-divider :key="'vd' + i" />
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-bottom-navigation fixed app grow :value="activeMenu">
      <v-btn @click="init(0)">
        <img src="assets/mnuac/main.png" style="width: 28px;" />
      </v-btn>
      <v-btn :value="2" @click="init(2)">
        <img src="assets/mnuac/student.png" style="width: 32px;" />
      </v-btn>
      <v-btn @click="$router.push({ name: 'login' })">
        <img src="assets/mnuac/home1.png" style="width: 28px;" />
      </v-btn>
    </v-bottom-navigation>

    <task-dialog
      :show.sync="taskDialog.show"
      :id="taskDialog.id"
      @on-hide="
        taskDialog.id = 0;
        taskDialog.show = false;
      "
    />

    <v-navigation-drawer v-model="drawerRight" clipped app right width="80%">
      <v-list dense>
        <v-list-item
          @click="programFilter(t.id)"
          v-for="(t, i) in pages"
          :key="i"
        >
          <v-list-item-action>
            <v-icon>mdi-chevron-left</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ t.task }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-subheader>Сургууль</v-subheader>
      <v-list>
        <v-list-item-group v-model="program.schoolCur" @change="init(2)">
          <v-list-item v-for="(t, i) in program.schools" :key="i" :value="t.id">
            <v-list-item-icon>
              <v-icon
                v-text="
                  t.id == program.schoolCur
                    ? 'mdi-checkbox-marked'
                    : 'mdi-square-outline'
                "
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="t.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-subheader>Болох хугацаа</v-subheader>
      <v-list>
        <v-list-item-group v-model="program.dateCur" @change="init(2)">
          <v-list-item v-for="(t, i) in program.dates" :key="i" :value="t.id">
            <v-list-item-icon>
              <v-icon
                v-text="
                  t.id == program.dateCur
                    ? 'mdi-checkbox-marked'
                    : 'mdi-square-outline'
                "
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="t.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-subheader>Сургалтын хэлбэр</v-subheader>
      <v-list>
        <v-list-item-group v-model="program.typeCur" @change="init(2)">
          <v-list-item v-for="(t, i) in program.types" :key="i" :value="t.id">
            <v-list-item-icon>
              <v-icon
                v-text="
                  t.id == program.typeCur
                    ? 'mdi-checkbox-marked'
                    : 'mdi-square-outline'
                "
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="t.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<style lang="scss">
.tytyty {
  width: 60px;
  height: 100px;
}
.tytydesc {
  width: calc(100% - 60px);
}
.tytyty img {
  border-radius: 10px;
}

.tytyty-title {
  color: #342b5b;
  font-weight: 500;
  font-size: 13px;

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 55px;
}
.fdsdfsdfdsfsdf .v-banner {
  border-bottom-left-radius: 20px !important;
  border-top-left-radius: 20px !important;
}
.fdsdfsdfdsfsdf .v-banner__wrapper {
  padding: 0 !important;
  border-bottom-left-radius: 20px !important;
  border-top-left-radius: 20px !important;
}

.fdsdfsdfdsfsdf .v-banner__wrapper .v-banner__content {
  padding: 0 !important;
  border-bottom-left-radius: 20px !important;
  border-top-left-radius: 20px !important;
}

.viceDirectors .-slide-group__prev,
.viceDirectors .-slide-group__next {
  min-width: 25px !important;
}
.viceDirectors .desc-outer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  line-height: 1.1;
}
.suis-carsl {
  .v-window__next {
    right: 0;
  }
}
</style>

<script>
import { getCoreList } from "@/api/taskCore";
import { getTypeTreeData } from "@/api/type";
import { mapActions } from "vuex";

import config from "@/config";
const { mobApps, mobAppActiveGroup } = config;

var _ = require("lodash");

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    taskDialog: () => ({
      component: import("@/views/apps/mnuac/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      taskDialog: {
        show: false,
        id: 0,
        key: 0
      },

      host: {},
      tasks: [],
      news: [],
      activeTab: 1,
      activeMenu: 0,

      mid9: [],
      top1: [],

      drawerRight: false,
      pages: [],
      program: {
        locCur: 35607,

        schools: [],
        schoolCur: 0,
        dates: [],
        dateCur: 0,
        types: [],
        typeCur: 0
      }
    };
  },
  mounted() {
    // this.host = mobApps.filter(x => x.id==mobAppActiveGroup)[0];
    // this.handleJWT({ key: this.host.key, store: this.$store }).then(JWT => {
    //   if (JWT != false) {
    //     this.init(0);
    //   }
    // });

    if (this.$store.state.app.isMobile) {
      this.init(0);
    } else {
      this.$router.push("login");
    }

    // this.handlePages({ store: this.$store });
  },
  methods: {
    ...mapActions(["handleJWT", "handleLoading", "handlePages"]),
    init(m) {
      this.activeMenu = m;
      this.handleLoading({ isLoading: true });

      this.tasks = [];
      let _data = {};
      if (m == 0) {
        _data = {
          ot: 357,
          size: 5,
          skip: 0,
          model: { isPublic: true, locTypeId1: 35650 }
        };
      } else if (m == 1) {
        _data = {
          ot: 357,
          size: 21,
          skip: 0,
          isPublic: true,
          model: { isPublic: true, locTypeId1: 35640 }
        };
      } else if (m == 2) {
        _data = {
          ot: 357,
          size: 100,
          skip: 0,
          model: {
            isPublic: true,
            locTypeId1: this.program.locCur,
            locTypeId3: this.program.schoolCur,
            locTypeId4: this.program.dateCur,
            locTypeId5: this.program.typeCur
          }
        };
      } else if (m == 3) {
        _data = {
          ot: 357,
          size: 21,
          skip: 0,
          isPublic: true,
          model: { isPublic: true, locTypeId1: 35614 }
        };
      } else if (m == 4) {
        _data = {
          ot: 357,
          size: 21,
          skip: 0,
          isPublic: true,
          model: { isPublic: true, locTypeId1: 35575 }
        };
      } else {
        _data = {
          ot: 357,
          size: 20,
          skip: 0,
          model: { isPublic: true, locTypeId1: 35614 }
        };
      }

      getCoreList({
        data: _data,
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.handleLoading({ isLoading: false });
          if (m == 0) {
            this.initTab(this.activeTab);
            this.tasks = res.data.tasks;
          } else if (m == 1) {
            this.tasks = _.orderBy(res.data.tasks, ["ord"], ["asc"]);
            this.top1 = this.tasks.slice(0, 1);
            this.mid9 = this.tasks.slice(1, 20);
          } else if (m == 2) {
            this.initTypes();
            this.initPages(384045);
            this.tasks = res.data.tasks;
          } else {
            this.tasks = res.data.tasks;
          }
        } else {
          this.handleLoading({ isLoading: false });
        }
      });
    },
    initTab(m) {
      this.activeTab = m;
      this.handleLoading({ isLoading: true });
      this.news = [];

      let _data = {};
      if (m == 0) {
        _data = {
          filterByNews: true,
          ot: 357,
          size: 5,
          skip: 0,
          model: { i1: 1, isPublic: true, locTypeId1: 35572 }
        };
      } else if (m == 1) {
        _data = {
          filterByNews: true,
          ot: 357,
          size: 20,
          skip: 0,
          model: { i1: null, isPublic: true, locTypeId1: 35572 }
        };
      } else if (m == 2) {
        _data = {
          filterByNews: true,
          ot: 357,
          size: 20,
          skip: 0,
          model: { i1: 1, isPublic: true, locTypeId1: 35572 }
        };
      }

      getCoreList({
        data: _data,
        store: this.$store
      }).then(res => {
        if (res != false) {
          if (m == 2)
            //this.news = _.dropRight(_.orderBy(res.data.tasks, ['viewCount'],['desc']), 15);

            this.news = _.orderBy(res.data.tasks, ["viewCount"], ["desc"]);
          else this.news = res.data.tasks;
          this.handleLoading({ isLoading: false });
        }
      });
    },
    initPages(pid) {
      this.pages = this.$store.state.app.pages.filter(
        x => x.i2 == 1 && x.parentId == pid
      );
      this.pages = _.sortBy(this.pages, "ord", "asc");
      //console.log(this.pages);
    },
    initTypes() {
      getTypeTreeData({
        params: { key: "suisProgramSchool" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.program.schools = res.data.types;
        }
      });

      getTypeTreeData({
        params: { key: "suisProgramDate" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.program.dates = res.data.types;
        }
      });

      getTypeTreeData({
        params: { key: "suisProgramType" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.program.types = res.data.types;
        }
      });
    },
    programFilter(tid) {
      if (tid == this.program.locCur) {
        this.program.locCur = 35607;
        this.init(2);
      } else {
        this.program.locCur = tid;
        this.init(2);
      }
    },
    showTask(e) {
      this.taskDialog.id = 0;
      this.$nextTick(() => {
        this.taskDialog.id = e.id;
        this.taskDialog.show = true;
      });
    }
  }
};
</script>
